import { Component, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent } from '@app/components/input-field/input-field.component';
import { AutoForm } from '@app/interfaces/auto-form.interface';
import { ProviderCreate } from '@app/models/provider.interface';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-provider-form',
    imports: [
        ReactiveFormsModule,
        InputFieldComponent,
    ],
    templateUrl: './form.component.html',
    styleUrl: './form.component.scss'
})
export class ProviderFormComponent {
  initialValue = input<ProviderCreate>();
  formChange = output<ProviderCreate>();
  formValid = output<boolean>();

  providerForm = new FormGroup<AutoForm<ProviderCreate>>({
    name: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    active: new FormControl<boolean>(true, {nonNullable: true}),
  });

  constructor() {
    toObservable(this.initialValue).subscribe((initial) => {
      if(initial) {
        Object.keys(initial).forEach(key => {
          // https://stackoverflow.com/a/62438434/3341745
          let prop = key as keyof typeof initial;
          if(initial[prop] != null) {
            this.providerForm.get(key)?.setValue(initial[prop]);
          }
        });
      }
      this.onChange();
    });
  }

  onChange() {
    this.formValid.emit(this.providerForm.valid);
    this.formChange.emit(<ProviderCreate>this.providerForm.value);
  }
}